"use client";
import React, { useState } from "react";
import Image from "next/image";
import { HiChevronDown, HiChevronUp } from "react-icons/hi2";
import { ScrollProgressBar } from "./ProgressBar";
import { IPackageDetailsItinerary } from "../interface/IPackageDetails.interface";

interface IProps {
  itinerary: IPackageDetailsItinerary[];
  activity?: any[];
  meals?: any[];
}

export const Itenary = ({ itinerary, activity, meals }: IProps) => {
  const [activeIndex, setActiveIndex] = useState<number | null>(0);
  const [imageIndex, setImageIndex] = useState<number[]>(() =>
    itinerary.map(() => 0)
  );

  const toggle = (index: number) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  const selectImage = (dayIndex: number, imgIndex: number) => {
    setImageIndex((prev) =>
      prev.map((v, i) => (i === dayIndex ? imgIndex : v))
    );
  };

  const scrollIds = itinerary.map((day) => ({
    id: day?.id,
    label: `${day?.day}`,
  }));

  return (
    <div id="itinerary" className="w-full">
      {/* Header */}
      <div className="bg-gradient-to-r from-[#9180BA] to-transparent py-3 px-3 text-white text-xl">
        Itinerary
      </div>

      <ScrollProgressBar sections={scrollIds} />

      {itinerary.map((day, i) => (
        <div key={day?.id} id={day?.id} className="scroll-mt-52 mb-12 px-4">
          <div
            onClick={() => toggle(i)}
            className="cursor-pointer flex justify-between items-center py-4 border-b"
          >
            <span className="text-gray-700 font-medium text-lg">
              Day {day?.day} | {day?.title}
            </span>
            {activeIndex === i ? <HiChevronUp /> : <HiChevronDown />}
          </div>

          {activeIndex === i && (
            <div className="mt-4">
              <div className="bg-gradient-to-r from-[#FFB700] to-transparent text-white px-4 py-2 rounded-l-3xl text-sm md:text-base">
                Highlights
              </div>

              {/* Image Section */}
              {day?.images && day?.images?.length > 0 && (
                <figure className="relative w-full mt-6 rounded-3xl overflow-hidden">
                  <div className="relative w-full h-64 md:h-[420px] rounded-3xl">
                    {day?.images?.map((img, idx) => (
                      <Image
                        key={idx}
                        src={img?.image || "/placeholder.png"}
                        alt={`Day ${day?.day} image ${idx}`}
                        width={400}
                        height={400}
                        className={`absolute w-full h-full object-cover rounded-3xl transition-opacity duration-500
                        ${imageIndex[i] === idx ? "opacity-100" : "opacity-0"}`}
                      />
                    ))}
                  </div>

                  <div className="absolute bottom-4 right-6 flex items-center gap-2">
                    {day?.images?.map((_, imgIdx) => (
                      <button
                        key={imgIdx}
                        onClick={() => selectImage(i, imgIdx)}
                        className={`w-8 h-8 rounded-full border border-white overflow-hidden
                        ${imageIndex[i] === imgIdx ? "opacity-100" : "opacity-40"}
                        ${imgIdx === 1 ? "-ml-2" : ""}`}
                      />
                    ))}
                  </div>
                </figure>
              )}

              <div className="mt-6 border p-3 rounded-xl flex flex-col gap-2 text-gray-700">
                <p className="font-medium">Details:</p>
                <p
                  className="text-gray-500"
                  dangerouslySetInnerHTML={{
                    __html: day?.description || "",
                  }}
                ></p>
                {activity && activity.length > 0 && (
                  <>
                    <p className="font-medium mt-2">Activity:</p>
                    {activity
                      .filter((act) => act?.itinerary?.id === day?.id)
                      .map((actItem: any) => (
                        <p
                          key={actItem?.id}
                          className="text-gray-500"
                          dangerouslySetInnerHTML={{
                            __html: actItem.description || "",
                          }}
                        />
                      ))}
                  </>
                )}
                {meals && meals.length > 0 && (
                  <div className="mt-4">
                    <p className="font-medium">Meals:</p>
                    {meals
                      .filter((meal) => meal?.itinerary?.id === day.id)
                      .map((mealItem) => (
                        <div key={mealItem.id} className="text-gray-500 mt-1">
                          <p className="font-semibold">{mealItem.title}</p>
                          <p
                            dangerouslySetInnerHTML={{
                              __html: mealItem.description || "",
                            }}
                          />
                        </div>
                      ))}
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
